import { XmControlErrorsTranslates } from '@xm-ngx/components/control-error';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export const errorTranslations: XmControlErrorsTranslates = {
    invalidUrl: marker('xm-control-errors.validators.invalidUrl'),
};
